import React from 'react';
import { TableData } from '../types';
import { getTableStats, getInitials } from '../utils/helpers';

interface TableListProps {
  filteredTables: TableData[];
  onTableClick: (table: TableData) => void;
}

export const TableList: React.FC<TableListProps> = ({ filteredTables, onTableClick }) => {
  if (filteredTables.length === 0) {
    return (
      <div style={{ padding: '32px', textAlign: 'center', color: '#6b7280' }}>
        No tables match your search or filter criteria.
      </div>
    );
  }

  return (
    <div style={{ 
      display: 'grid', 
      gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', 
      gap: '16px' 
    }}>
      {filteredTables.map(table => {
        const stats = getTableStats(table);
        return (
          <div key={table.tableName + Math.random()} 
               style={{
                 background: 'white',
                 border: '1px solid #e5e7eb',
                 borderRadius: '8px',
                 overflow: 'hidden',
                 cursor: 'pointer',
                 transition: 'transform 0.2s, box-shadow 0.2s'
               }}
               onClick={() => onTableClick(table)}
               onMouseEnter={(e) => {
                 e.currentTarget.style.transform = 'translateY(-2px)'
                 e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.1)'
               }}
               onMouseLeave={(e) => {
                 e.currentTarget.style.transform = 'translateY(0)'
                 e.currentTarget.style.boxShadow = 'none'
               }}
          >
            <div style={{
              padding: '12px 16px',
              background: '#f8fafc',
              borderBottom: '1px solid #e5e7eb',
              fontWeight: 600,
              color: '#1f2937',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center'
            }}>
              <span>{table.tableName}</span>
              <div style={{ display: 'flex', gap: '12px', fontSize: '0.875rem', color: '#6b7280' }}>
                <span style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                  <span style={{ width: '8px', height: '8px', borderRadius: '50%', background: '#22c55e' }}></span>
                  {stats.checkedIn}
                </span>
                <span style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                  <span style={{ width: '8px', height: '8px', borderRadius: '50%', background: '#ef4444' }}></span>
                  {stats.notCheckedIn}
                </span>
                <span style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                  <span style={{ width: '8px', height: '8px', borderRadius: '50%', background: '#9ca3af' }}></span>
                  {stats.emptySeats}
                </span>
              </div>
            </div>
            <div style={{
              padding: '12px',
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fill, minmax(130px, 1fr))',
              gap: '8px'
            }}>
              {table.attendees.slice(0, 4).map(attendee => (
                <div key={attendee.id} style={{
                  padding: '8px',
                  borderRadius: '6px',
                  background: '#f9fafb',
                  border: '1px solid #e5e7eb',
                  fontSize: '0.875rem',
                  borderLeft: `3px solid ${attendee.assignedTicket?.checkedIn ? '#22c55e' : '#ef4444'}`
                }}>
                  <div style={{ fontWeight: 500, color: '#1f2937', marginBottom: '2px' }}>
                    {attendee.name}
                  </div>
                  <div style={{ color: '#6b7280', fontSize: '0.8rem' }}>
                    {attendee.company || ''}
                  </div>
                  {attendee.mealType && (
                    <div style={{ color: '#8b5cf6', fontSize: '0.75rem', fontWeight: 500 }}>
                      {attendee.mealType}
                    </div>
                  )}
                  {/* Ticket Name Badge */}
                  {attendee.assignedTicket?.name && (
                    <div style={{ 
                      display: 'inline-block',
                      padding: '1px 4px',
                      backgroundColor: '#dbeafe',
                      color: '#1e40af',
                      borderRadius: '3px',
                      fontSize: '0.65rem',
                      fontWeight: 500,
                      marginTop: '2px'
                    }}>
                      {attendee.assignedTicket.name}
                    </div>
                  )}
                </div>
              ))}
              {table.attendees.length > 4 && (
                <div style={{
                  padding: '8px',
                  borderRadius: '6px',
                  background: '#f3f4f6',
                  border: '1px solid #e5e7eb',
                  fontSize: '0.875rem',
                  color: '#6b7280',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontStyle: 'italic'
                }}>
                  +{table.attendees.length - 4} more
                </div>
              )}
            </div>
          </div>
        )
      })}
    </div>
  );
}; 